import baseConfig, { Config } from "../../utils/config";

// Visual query demo - venetian
const visualqueryaiConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "", //"/content/demo_user/architectural-plan.dwg",
  ServerBackEndUrl: "http://localhost:3000", // "https://server.demo.cadviewer.com", //"http"http://localhost:3000"://localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "http://localhost:3001", //"http://vizquery.cadviewer.com", //"https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: false, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: true, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: false, // hide the left hamburger menu
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": 0.0, // 0.1
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": 0.5,
    stroke: "#a4d7f4",
    "stroke-width": 0.2,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": 0.5,
    stroke: "#5BBEF6",
    "stroke-width": 0.23,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  postFixServerToken: false,
  globalApplicationFilesLocation:
    "http://localhost:3000/content/vizquery_demo/json/application/",
  propertySVGFilesLocation: "http://localhost:3000/content/vizquery_demo/svg/",
  propertyJSONFilesLocation:
    "http://localhost:3000/content/vizquery_demo/json/property/",
  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "0311", //"2339", // set to undefined to disable default property
    planName: "LP1", //"LP0", // set to undefined to disable default plan
  },
  enableQuickPdfPrint: true,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: true, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items
  enableRightJSONModalPanel: true, // enabling JSON load right side pane for property selection
  enableRightFileModalPanel: false,
  setCADViewerSkin: "light-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin
  setBPLayerChange: true,
  serverSubFolder: "/drawings/dwg/", // the subfolder where the drawings are located, relative to the server URL,
  showOnlySubFolder: true, // if true, only show the serverSubFolder and its children, hide the rest of the tree
  showLogoOnSideBarLeftPanel: true, // Set to true to display the logo on the side bar left panel
  cvjs_styleQTip_width: "320px", // set the width of the popup
  debugMode: false, // enables CADViewer debug traces in the browser
  enableHelperMethods: false,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: true,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,




  enableAIChat: true,
  useAIChatV5: true,
  useAIChatV4: false,

  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")



  omitSpaceObjectLayerHandling: false,
};

export default visualqueryaiConfig;
